import Vue from 'vue'
import Vuex from 'vuex'
import settings from './modules/settings'
import dict from './modules/dict'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    //引入全局变量文件
    settings,
    dict
  },
  state: {
    //属性
    sessionId: '',
    sessionIdChange: '',
    MenuPermission: '',
    UserName: '',
    ActiveName: '',
    ActiveMenu: '',
    Versions: 4,
    DeviceMesOne: {},
    Menu: [],
    CurrentUser: [],
    userInfo: {},
    color: {
      '0': {status: 0, description: '信号未定义', color: '#888888',},
      '1': {status: 1, description: '异常停止', color: '#ff2f00',},
      '2': {status: 2, description: '停止', color: '#ffd735',},
      '3': {status: 3, description: '运转', color: '#34ce01',},
      '4': {status: 4, description: '掉线', color: '#888888'}
    },

	//NWC正式
	 postUrl: "https://inbis-fms.com/api/",
	 //NWC本地
	  // postUrl: "http://localhost:8830/api/",
	  // postUrl: "http://localhost:8081/",
		//顾明
		// postUrl: "http://10.200.0.52:8081/",
		//王海宇v
		// postUrl: "http://192.168.0.100:8101/api/",

    appDownloadURL: "https://inbis-fms.com/app/device.apk",
    downloadAppFlag: 1,
    logoClass: "logoNWC",
    languageName: 'ja',
    showMap: false,
  },

  getters: {
    //这里是get方法
    getPostUrl: state => state.postUrl,
    getLanguageName: state => state.languageName,
    getSessionId: state => state.sessionId,
    getSessionIdChange: state => state.sessionIdChange,
    getUserInfo: state => state.userInfo,
    getMenuPermission: state => state.MenuPermission,
    getDeviceMesOne: state => state.DeviceMesOne,
    getUserName: state => state.UserName,
    getActiveName: state => state.ActiveName,
    getActiveMenu: state => state.ActiveMenu,
    getMenu: state => state.Menu,
    getCurrentUser: state => state.CurrentUser,
    getColor: state => state.color,
    getVersions: state => state.Versions,
    getAppDownloadURL: state => state.appDownloadURL,
    getLogoClass: state => state.logoClass,
    getDownloadAppFlag: state => state.downloadAppFlag,
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    dict: state => state.dict.dict,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    topbarRouters: state => state.permission.topbarRouters,
    defaultRoutes: state => state.permission.defaultRoutes,
    sidebarRouters: state => state.permission.sidebarRouters,
    getShowMap: state => state.showMap,
  },
  mutations: {
    setDownloadAppFlag(state, downloadAppFlag) {
      state.downloadAppFlag = downloadAppFlag;
    },
    setLogoClass(state, logoClass) {
      state.logoClass = logoClass;
    },
    setLanguageName(state, languageName) {
      state.languageName = languageName;
    },
    setAppDownloadURL(state, downloadURL) {
      state.appDownloadURL = downloadURL;
    },
    setPostUrl(state, postUrl) {
      state.postUrl = postUrl;
    },
    //这里是set方法
    setSessionId(state, sessionId) {
      state.sessionId = sessionId
    },
    setSessionIdChange(state, sessionIdChange) {
      state.sessionIdChange = sessionIdChange
    },
    setVersions(state, Versions) {
      state.Versions = Versions;
    },
    setCurrentUser(state, CurrentUser) {
      state.CurrentUser = CurrentUser
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setMenu(state, Menu) {
      state.Menu = Menu
    },
    setActiveMenu(state, ActiveMenu) {
      state.ActiveMenu = ActiveMenu
    },
    setActiveName(state, ActiveName) {
      state.ActiveName = ActiveName
    },
    setMenuPermission(state, menu) {
      state.MenuPermission = menu
    },
    setDeviceMesOne(state, DeviceMesOne) {
      state.DeviceMesOne = DeviceMesOne
    },
    setUserName(state, UserName) {
      state.UserName = UserName
    },
    setColor(state, color) {
      state.color = color
    },
    setShowMap(state, showMap) {
      state.showMap = showMap
    },
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js